function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class MissingPartitionError extends Error {
  constructor() {
    super(...arguments);
    _defineProperty(this, "isMissingPartitionError", true);
  }
}
export function isMissingPartitionError(err) {
  return (err === null || err === void 0 ? void 0 : err.isMissingPartitionError) === true;
}
export default MissingPartitionError;
//# sourceMappingURL=MissingPartitionError.js.map